import { render, staticRenderFns } from "./form-area.vue?vue&type=template&id=4779948d"
import script from "./form-area.vue?vue&type=script&lang=js"
export * from "./form-area.vue?vue&type=script&lang=js"
import style0 from "./form-area.vue?vue&type=style&index=0&id=4779948d&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports